import React, { useEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import ReviewsIoWidget from '../../../../../components/ReviewsIoWidget';
import { segmentTracking } from '../../../../../services/utilities';
import HowItWorks from '../extras/HowItWorks';
import SocialProof from '../extras/SocialProof';

import { VARIANT_1, VARIANT_2 } from './variants';

import styles from './RPIntroPage.module.scss';

const RPIntroPage = ({ variant, location }) => {
  useEffect(() => {
    segmentTracking('page viewed', {
      location,
    });
  }, []);

  const variantData = variant === 'variant_1' ? VARIANT_1 : VARIANT_2;
  return (
    <div className={styles.container}>
      <HowItWorks location={location} variant={variantData} />
      <div className={cx(styles.extraInfoContainer)}>
        <SocialProof className={styles.socialProof} />

        <div className={styles.centeredRow}>
          <ReviewsIoWidget />
        </div>
      </div>
    </div>
  );
};

RPIntroPage.propTypes = {
  variant: PropTypes.string,
  location: PropTypes.string,
};

export default RPIntroPage;
